export { ModalBody } from '../src/ModalBody';
